import React from "react";
import { Script } from "gatsby";
import { SITE_URL } from "utils/constants";

const SiteRichSnippet = () => {
	const structuredData = {
		"@context": "https://schema.org/",
		"@type": "Organization",
		name: "MOD LIGHTING",
		url: SITE_URL,
		logo: "https://mod-lighting.com/cdn/shop/files/Untitled_design_-_2022-11-24T210312.964.png?v=1669341798&width=500",
		sameAs: [
			"https://www.facebook.com/shopmodlighting",
			"https://www.pinterest.ca/modlighting/",
			"https://www.instagram.com/modlightingshop",
		],
	};

	return <Script async type="application/ld+json">{JSON.stringify(structuredData)}</Script>;
};

export default SiteRichSnippet;
